import { cva, type VariantProps } from 'class-variance-authority';

/**
 * HEN Link variants using HEN Design System tokens.
 * All styling references design tokens defined in tailwind.config.ts.
 */
export const linkVariants = cva(
  [
    'inline-flex items-center gap-2',
    'font-medium',
    'transition-colors duration-200',
    'focus-visible:outline-none',
  ],
  {
    variants: {
      variant: {
        primary: [
          'text-primary-700',
          'underline-offset-4 hover:underline',
          'hover:text-primary-500',
          'active:text-primary-900',
        ],
        secondary: [
          'text-secondary-700',
          'underline-offset-4 hover:underline',
          'hover:text-secondary-500',
          'active:text-secondary-900',
        ],
        tertiary: [
          'text-tertiary-700',
          'underline-offset-4 hover:underline',
          'hover:text-tertiary-500',
          'active:text-tertiary-900',
        ],
        default: [
          'text-link-base',
          'underline-offset-4 hover:underline',
          'hover:text-link-hover',
        ],
        black: [
          'text-black',
          'underline-offset-4 hover:underline',
          'hover:text-neutral-700',
          'active:text-neutral-900',
        ],
        white: [
          'text-white',
          'underline-offset-4 hover:underline',
          'hover:text-neutral-200',
          'active:text-neutral-100',
        ],
      },
      size: {
        sm: 'text-sm',
        md: 'text-base',
        lg: 'text-lg',
      },
      underline: {
        always: 'underline',
        hover: 'no-underline hover:underline',
        none: 'no-underline hover:no-underline',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'md',
      underline: 'hover',
    },
  },
);

export type LinkVariantProps = VariantProps<typeof linkVariants>;
